export default __webpack_public_path__ + "static/media/kl-07.dec1ce20.png";